
    <app-breadcrumb-renderer
      *ngFor="let breadcrumb of (breadcrumbs | async); let i = index"
      [breadcrumb]="breadcrumb"
      [index]="i"
      class="renderer"
    >
    </app-breadcrumb-renderer>
  